module.exports = __webpack_public_path__ + "img/buildings.99044e46.png";